import { $selectedDates, setSelectedPreferredDays } from "./selectedDateRange";
import { $selectedLocation } from "./selectedLocations";
import { resetSelectedPersonTypes } from "./selectedPersonTypes";
import { combine } from "effector";
import { $selectedPackages } from "./selectedPackages";
import { $selectedActivities } from "./selectedActivities";
import { countdownApi } from "../shared/countdown";

$selectedLocation.watch(() => resetSelectedPersonTypes());

$selectedDates.watch(() => setSelectedPreferredDays([]));

combine($selectedPackages, $selectedActivities).watch(
  ([packages, activities]) => {
    if (packages.length === 0 && activities.length === 0) {
      countdownApi.stop();
    }
  }
);
